import { DeleteOutlined, LockOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ColumnBaseProps } from '../types';

import s from './RequiredFieldColumn.module.scss';

const RequiredFieldColumn: React.FC<ColumnBaseProps> = ({
  record,
  editFormStore,
}) => {
  const { deleteFormField } = editFormStore;

  const handleDelete = React.useCallback(() => {
    deleteFormField(record);
  }, [deleteFormField, record]);

  return (
    <Button
      type="link"
      disabled={record.catalogField.required}
      onClick={handleDelete}
      icon={
        record.catalogField.required ? (
          <LockOutlined className={s.column__icon} />
        ) : (
          <DeleteOutlined className={s.column__icon} />
        )
      }
    />
  );
};

export default observer(RequiredFieldColumn);
